// extracted by mini-css-extract-plugin
export default {"container":"whyKStripe_container__AilOm","wrapper":"whyKStripe_wrapper__Gl6im","buttonK":"whyKStripe_buttonK__ZuRxF","img":"whyKStripe_img__+AsI4"};